import { useEffect } from 'react';

export const PreloadImage = ({ condition = true, href, imageSrcSet }) => {
  const avoidDuplicate = (href, imageSrcSet) => {
    const links = document.querySelectorAll('.preload-image');
    const link = Array.from(links).find(
      (link) =>
        link.getAttribute('href') === href ||
        link.getAttribute('imageSrcSet') === imageSrcSet,
    );
    return link;
  };
  useEffect(() => {
    if (!condition) return;
    if (avoidDuplicate(href, imageSrcSet)) return;
    const link = document.createElement('link');
    link.setAttribute('class', 'preload-image');
    link.setAttribute('rel', 'preload');
    link.setAttribute('as', 'image');
    link.setAttribute('fetchpriority', 'high');
    if (href) link.setAttribute('href', href);
    if (imageSrcSet) link.setAttribute('imageSrcSet', imageSrcSet);
    document.head.appendChild(link);
  }, [condition]);

  return null;
};
